<template>
  <div id="app" :class="isPc ? '' : 'phone'">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
import { IsPC } from "@/utils/util";
import "@/style/base.css";
import "@/style/index.css";
import "@/style/icon.css";
import "@/style/home.css";
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isPc: IsPC(),
      isRouterAlive: true,
      stylePC: {}
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/App.vue